/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateBillingSubscriptionData
 */
export interface UpdateBillingSubscriptionData {
    /**
     * 
     * @type {number}
     * @memberof UpdateBillingSubscriptionData
     */
    billingPackageId: number;
}

/**
 * Check if a given object implements the UpdateBillingSubscriptionData interface.
 */
export function instanceOfUpdateBillingSubscriptionData(value: object): value is UpdateBillingSubscriptionData {
    if (!('billingPackageId' in value) || value['billingPackageId'] === undefined) return false;
    return true;
}

export function UpdateBillingSubscriptionDataFromJSON(json: any): UpdateBillingSubscriptionData {
    return UpdateBillingSubscriptionDataFromJSONTyped(json, false);
}

export function UpdateBillingSubscriptionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBillingSubscriptionData {
    if (json == null) {
        return json;
    }
    return {
        
        'billingPackageId': json['billingPackageId'],
    };
}

  export function UpdateBillingSubscriptionDataToJSON(json: any): UpdateBillingSubscriptionData {
      return UpdateBillingSubscriptionDataToJSONTyped(json, false);
  }

  export function UpdateBillingSubscriptionDataToJSONTyped(value?: UpdateBillingSubscriptionData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'billingPackageId': value['billingPackageId'],
    };
}

